<template>
  <div>
    <ElRow>
      <ElCol :span="22">
        <h1>Partners</h1>
      </ElCol>
      <ElCol :span="2">
        <ElButton
          @click="add"
          size="small"
          icon="el-icon-plus"
        >
          Add
        </ElButton>
      </ElCol>
    </ElRow>

    <ElDialog
      :visible.sync="dialogVisible"
      width="100%"
    >
      <span slot="title">
        <h3><i class="fa fa-edit" /> Edit Partner</h3>
      </span>

      <ElForm
        ref="form"
        :model="formData"
        label-width="10%"
      >
        <ElRow
          v-for="field in form.fields"
          :key="field.name"
        >
          <ElFormItem
            v-if="field.type === 'id'"
            :label="field.label"
            :key="field.name"
          >
            <!--hidden id: {{formData.uuid}}-->
          </ElFormItem>

          <ElFormItem
            v-if="field.type === 'string'"
            :label="field.label"
            :key="field.name"
          >
            <ElInput v-model="formData[field.name]" />
          </ElFormItem>

          <ElFormItem
            v-if="field.type === 'text'"
            :label="field.label"
            :key="field.name"
          >
            <ElInput
              type="textarea"
              v-model="formData[field.name]"
            />
          </ElFormItem>

          <ElFormItem
            v-if="field.type === 'image'"
            :label="field.label"
            :key="field.name"
          >
            <div>
              <div style="float:left">
                <ElUpload
                  class="image-uploader"
                  action="/api/doUpload"
                  :data="formContext(field.name)"
                  :show-file-list="false"
                  :on-success="handleUploadSuccess"
                  :before-upload="validateUpload"
                >
                  <img
                    v-if="image(field.name)"
                    :src="image(field.name)"
                    class="image"
                  />
                  <i
                    v-else
                    class="el-icon-plus image-uploader-icon"
                  />
                </ElUpload>
                <ElButton
                  icon="el-icon-delete"
                  @click="remove(field.name)"
                  v-if="image(field.name)"
                >
                  remove
                </ElButton>
              </div>

              <div
                class="preview-container"
                style="margin-left: 300px;"
              >
                <div class="preview-item">
                  <p><strong>Preview on White</strong></p>
                  <img
                    v-if="image(field.name)"
                    :src="image(field.name)"
                    class="image"
                  />yy
                </div>
                <div
                  class="preview-item"
                  style="background-color:black"
                >
                  <p style="color:white">
                    <strong>Preview on Black</strong>
                  </p>

                  <img
                    v-if="image(field.name)"
                    :src="image(field.name)"
                    class="image"
                  />{{ field }}
                </div>
              </div>

              <ElInput
                type="hidden"
                v-model="form[field.name]"
              />
            </div>
            <hr />
          </ElFormItem>
        </ElRow>

        <ElRow>
          <ElButton
            type="primary"
            class="centerbutton"
            :disabled="saveDisabled"
            native-type="submit"
            @click="validate('form')"
            icon="el-icon-save"
          >
            Save
          </ElButton>
        </ElRow>
      </ElForm>
    </ElDialog>

    <ElTable
      :data="list"
      stripe
      style="width: 100%"
    >
      <ElTableColumn
        v-for="t in tableCols"
        :prop="t.name"
        :label="t.label"
        :key="t.name"
      />
      <ElTableColumn label="Operations">
        <template slot-scope="scope">
          <ElButton
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
            icon="el-icon-edit"
          >
            Edit
          </ElButton>
          <ElButton
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
            icon="el-icon-delete"
          >
            Delete
          </ElButton>
        </template>
      </ElTableColumn>
    </ElTable>
  </div>
</template>
<script>
import { API } from "../tic"
import store from "@/store"

let form = {
  title: "Partners",
  store: "Partner",
  api: "/api/Partners",
  fields: [
    {
      name: "uuid",
      type: "id"
    },
    {
      name: "name",
      type: "string",
      label: "Name",
      hint: "Name of the institute/partner",
      inList: true
    },
    {
      name: "code",
      type: "string",
      label: "Code",
      hint: "Short identifier for internal use",
      inList: true
    },
    {
      name: "short",
      type: "text",
      label: "Short description",
      inList: true
    },
    {
      name: "long",
      type: "text",
      label: "Long description"
    },
    {
      name: "logo",
      type: "image",
      label: "Logo",
      node: {
        relation: "IS_LOGO",
        name: "Upload"
      }
    },
    {
      name: "icon",
      type: "image",
      label: "Icon",
      node: {
        relation: "IS_ICON",
        name: "Upload"
      }
    }
  ]
}

export default {
  name: "Partners",

  watch: {
    formData: {
      handler: function (e) {
        this.saveDisabled = false
      },
      deep: true
    }
  },

  computed: {
    tableCols (e) {
      return this.form.fields.filter(e => {
        return e.inList
      })
    }
  },

  mounted () {
    console.log("mounted partners")
    API.post("/generic-list", this.form).then(resp => {
      console.log("get list resppsone: ", resp)
      this.list = resp.data.records
    })
  },

  methods: {
    handleEdit (e, row) {
      console.log("handleEdit e: ", e, " row: ", row)
      API.post("/generic-edit", { uuid: row.uuid }).then(resp => {
        console.log("edit record: ", resp.data)
        this.formData = resp.data.record
        this.uploads = resp.data.relations
        this.dialogVisible = true
      })
    },

    handleDelete (e, row) {
      let vm = this
      API.post("/generic-delete", { uuid: row.uuid }).then(resp => {
        vm.list.splice(e, 1)
      })
      console.log("handleDelete e: ", e, " row: ", row)
    },

    add () {
      this.formData = {}
      this.dialogVisible = true
      this.list.push(this.formData)
    },

    validate (form) {
      let vm = this
      console.log(">> validate form: ", form)
      this.form.data = this.formData
      this.form.relations = this.uploads
      API.post("/generic", this.form)
        .then(resp => {
          console.log("resp: ", resp)
          console.log("got id: ", resp.data.uuid)
          vm.$set(vm.formData, "uuid", resp.data.uuid)
          this.dialogVisible = false
        })
        .catch(r => {
          this.$alert(r.response.data, r.response.statusText)
        })
      return true
    },

    // remove a relation
    remove (name) {
      console.log("remove: ", name)
      this.uploads = this.uploads.filter(e => {
        return e.context !== name
      })
    },

    // get url of image for `name` context
    image (name) {
      let a = this.uploads.find(e => {
        if (e.context === name) {
          return e.url
        }
      })
      return a ? a.url : null
    },

    // additional data send via request.form
    formContext (context) {
      return {
        context: `${context}`, // fieldname is context
        user: this.$store.getters["user/uuid"],
        partner: this.formData["uuid"]
      }
    },

    handleUploadSuccess (res, file) {
      console.log("UPLOAD RESULT: ", res)
      this.uploads.push(res.data)
      // this.imageUrl = URL.createObjectURL(file.raw);
      // this.record.avatar = `/ua/avatars/${this.$store.getters['user/uuid']}.jpg`
      // this.save()
    },

    validateUpload (file) {
      const isJPG = true //file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error("picture must be JPG format!")
      }
      if (!isLt2M) {
        this.$message.error("picture size can not exceed 2MB!")
      }
      return isJPG && isLt2M
    }
  },

  data () {
    return {
      list: [],
      saveDisabled: true,
      uploads: [],
      fields: form.fields,
      formData: {},
      form: form,
      dialogVisible: false
    }
  }
}
</script>
<style scoped>
label.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
  font-weight: normal !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
</style>